enum FeatureFlags {
  FEATURE_FLAG_BULK_EDIT_COLUMNS = 'bulkEditColumns',
  FEATURE_FLAG_BULK_IMPORT_V2 = 'bulkImportV2',
  FEATURE_FLAG_FILTER_CAMPAIGNS = 'filterCampaigns',
  FEATURE_FLAG_REPORT_TIME_COMPARISON = 'reportTimeComparison',
  FEATURE_FLAG_SORT_REPORTS_CNX_TYPE = 'sortReportsConstituentType',
  DEPRECATE_BULK_EDIT_V1 = 'deprecateBulkEditV1',
  HOUSEHOLD_ENHANCEMENTS = 'householdEnhancements',
  IS_DECEASED = 'isDeceased',
  IWAVE = 'iwave',
  CONSTITUENT_COLUMN_SELECTION = 'constituentColumnSelection',
  MIGRATION_COMPLETED = 'migrationCompleted',
  MIGRATION_STARTED = 'migrationStarted',
  OPPORTUNITIES_GROUPING = 'opportunitiesGrouping',
  OPPORTUNITIES_LINKING = 'opportunitiesLinking',
  OPPORTUNITIES_MILESTONE_1 = 'opportunitiesMilestone1',
  OPPORTUNITIES_MILESTONE_2 = 'opportunitiesMilestone2',
  OPPORTUNITIES_MILESTONE_3 = 'opportunitiesMilestone3',
  OPPORTUNITIES_REPORTS = 'opportunitiesReports',
  SALESFORCE_MILESTONE_1 = 'salesforceMilestone1',
}

export default FeatureFlags;
